import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import OldStudentProfileLayout from './OldStudentProfileLayout';

// import utility file
import EleveService from '../../services/EleveService';
import SalledeclasseService from '../../services/SalledeclasseService';
import GKStepper from '../../../elements/stepper/GKStepper';
import EditOldInfoPersonnelles from './steps/EditOldInfoPersonnelles';
import EditOldInfoMedicales from './steps/EditOldInfoMedicales';
import EditOldInfoScolaires from './steps/EditOldInfoScolaires';
import { Alert, Form } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import AnneescolaireService from '../../services/AnneescolaireService';

const ViewOldStudent = () => {
	const [student, setStudent] = useState(null);
	const { id } = useParams();
	const [personalInfo, setPersonalInfo] = useState({});
	const [medicalInfo, setMedicalInfo] = useState({});
	const [schoolInfo, setSchoolInfo] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [currentSchoolYear, setCurrentSchoolYear] = useState(null);

	const handlePersonalInfoChange = (data) => {
		setPersonalInfo(data);
	};

	const handleMedicalInfoChange = (data) => {
		setMedicalInfo(data);
	};

	const handleSchoolInfoChange = (data) => {
		setSchoolInfo(data);
	};

	useEffect(() => {
		const fetchCurrentSchoolYear = async () => {
			try {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();
				setCurrentSchoolYear(schoolYear.data);
			} catch (error) {
				console.error(
					"Erreur lors de la récupération de l'année scolaire en cours:",
					error
				);
				alert(
					`Erreur lors de la récupération de l'année scolaire en cours. Détails de l'erreur : ${error.message}`
				);
			}
		};

		fetchCurrentSchoolYear();
	}, []);

	useEffect(() => {
		Promise.all([
			EleveService.getEleve(id),
			SalledeclasseService.getAllSalledeclasse()
		]).then(([eleveData]) => {
			setStudent(eleveData.data);

			setPersonalInfo({
				nom: eleveData.data.nom,
				prenom: eleveData.data.prenom,
				date_naissance: eleveData.data.date_naissance,
				lieu_naissance: eleveData.data.lieu_naissance,
				genre: eleveData.data.genre,
				langue_maternelle: eleveData.data.langue_maternelle,
				photo: eleveData.data.photo
			});

			setMedicalInfo({
				maladie_congenitale: eleveData.data.maladie_congenitale,
				maladie_chronique: eleveData.data.maladie_chronique,
				allergie_aliment: eleveData.data.allergie_aliment,
				allergie_medicament: eleveData.data.allergie_medicament,
				allergie_autre_substance: eleveData.data.allergie_autre_substance,
				photocopie_carnet_vaccination:
					eleveData.data.photocopie_carnet_vaccination
			});

			const is_new_student = !!eleveData.data.ancienne_ecole;

			setSchoolInfo({
				statut_eleve: eleveData.data.statut_eleve,
				ancienne_ecole: eleveData.data.ancienne_ecole,
				classe_redoublement:
					eleveData.data.classe_redoublement ??
					eleveData.data.classe_redoublement_new,
				bulletin_notes_annee_precedente:
					eleveData.data.bulletin_notes_annee_precedente,
				salledeclasse: eleveData.data.salledeclasse,
				is_new_student: is_new_student
			});
		});
	}, [id]);

	const [currentStep, setCurrentStep] = useState(1);
	const next = () => {
		setCurrentStep(currentStep === 3 ? 1 : currentStep + 1);
	};
	const previous = () => {
		setCurrentStep(currentStep === 1 ? 1 : currentStep - 1);
	};

	const steps = [
		{
			id: 1,
			title: 'Informations personnelles',
			content: (
				<EditOldInfoPersonnelles
					next={next}
					onChange={handlePersonalInfoChange}
					initialValues={personalInfo} // Ajoutez cette ligne
				/>
			)
		},
		{
			id: 2,
			title: 'Informations médicales',
			content: (
				<EditOldInfoMedicales
					next={next}
					previous={previous}
					onChange={handleMedicalInfoChange}
					initialValues={medicalInfo}
				/>
			)
		},
		{
			id: 3,
			title: 'Informations scolaires',
			content: (
				<EditOldInfoScolaires
					previous={previous}
					onChange={handleSchoolInfoChange}
					initialValues={schoolInfo}
				/>
			)
		}
	];

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const studentData = new FormData();

				if (currentSchoolYear === null) {
					alert(
						"Erreur lors de la récupération de l'année scolaire en cours. Veuillez réessayer plus tard."
					);
					return;
				}

				// Add all your form data to the FormData
				studentData.append('nom', personalInfo.nom);
				studentData.append('prenom', personalInfo.prenom);
				studentData.append('date_naissance', personalInfo.date_naissance);
				studentData.append('lieu_naissance', personalInfo.lieu_naissance);
				studentData.append('genre', personalInfo.genre);
				studentData.append('langue_maternelle', personalInfo.langue_maternelle);
				studentData.append('statut_eleve', schoolInfo.statut_eleve);
				studentData.append('ancienne_ecole', schoolInfo.ancienne_ecole);

				if (schoolInfo.is_new_student) {
					studentData.append(
						'classe_redoublement',
						schoolInfo.classe_redoublement ? schoolInfo.classe_redoublement : ''
					);
				} else {
					studentData.append(
						'classe_redoublement_new',
						schoolInfo.classe_redoublement ? schoolInfo.classe_redoublement : ''
					);
				}

				studentData.append(
					'maladie_congenitale',
					medicalInfo.maladie_congenitale
				);
				studentData.append('maladie_chronique', medicalInfo.maladie_chronique);
				studentData.append('allergie_aliment', medicalInfo.allergie_aliment);
				studentData.append(
					'allergie_medicament',
					medicalInfo.allergie_medicament
				);
				studentData.append(
					'allergie_autre_substance',
					medicalInfo.allergie_autre_substance
				);
				studentData.append('salledeclasse', schoolInfo.salledeclasse);
				studentData.append('anneescolaire', currentSchoolYear.id);

				if (personalInfo.photo && personalInfo.photo.file) {
					studentData.append('photo', personalInfo.photo.file);
				}
				if (
					medicalInfo.photocopie_carnet_vaccination &&
					medicalInfo.photocopie_carnet_vaccination.file
				) {
					studentData.append(
						'photocopie_carnet_vaccination',
						medicalInfo.photocopie_carnet_vaccination.file
					);
				}
				if (
					schoolInfo.bulletin_notes_annee_precedente &&
					schoolInfo.bulletin_notes_annee_precedente.file
				) {
					studentData.append(
						'bulletin_notes_annee_precedente',
						schoolInfo.bulletin_notes_annee_precedente.file
					);
				}

				// Call the EleveService to create the student
				const response = await EleveService.updateEleve(id, studentData);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error(
					"Erreur lors de la mise à jour des informations de l'élève",
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<OldStudentProfileLayout>
			{student && (
				<>
					{/*  Form  */}
					<Form
						className="mb-3"
						noValidate
						validated={validated}
						onSubmit={handleSubmit}
					>
						{showAlert && (
							<Alert variant="danger">
								<ExclamationTriangleFill size={25} className="me-1" />
								{alertMessage}
							</Alert>
						)}

						<GKStepper currentStep={currentStep} steps={steps} />
					</Form>
				</>
			)}
		</OldStudentProfileLayout>
	);
};

export default ViewOldStudent;
